import memoize from 'lru-memoize';
import { createValidator, required, money, minLength, maxLength } from '../../utils/validation';

const newAccountValidation = createValidator({
  dealerId: [required, minLength(4)],
  companyName: required,
  address: required,
  city: required,
  state: required,
  zipCode: required,
  routingNumber: [required, minLength(9), maxLength(9)],
  accountNumber: required,
  accountType: required,
  bankName: required,
  submittedByName: required,
  submittedByEmail: required,
  amount: [required, money],
  depositType: required,
});
export default memoize(10)(newAccountValidation);
